<script setup>
import { RouterView } from 'vue-router'
import ItemAddedAlert from '@/components/alerts/ItemAddedAlert.vue'
import ItemRemovedAlert from '@/components/alerts/ItemRemovedAlert.vue'
import ToastContainer from '@/components/common/ToastContainer.vue'
import { useUiSettingsStore } from '@/stores/uiSettingsStore'
import { onMounted } from 'vue'

const uiSettings = useUiSettingsStore()

onMounted(() => {
  uiSettings.initSettings()
})
</script>
<template>
  <router-view />
  <ItemAddedAlert></ItemAddedAlert>
  <ItemRemovedAlert></ItemRemovedAlert>
  <ToastContainer />
</template>
